var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2234 33.1482L42.2325 33.1433H42.2148L31.8391 27.521L21.4461 21.8889L11.0527 27.521L0.677019 33.1433H0.659363L0.668396 33.1482L0.659363 33.1531H0.677019L11.0527 38.7754L21.4461 44.4075L31.8391 38.7754L42.2148 33.1531H42.2325L42.2234 33.1482Z",
    fill: "#C4EFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2234 11.5544L42.2325 11.5499H42.2148L31.8391 5.92728L21.4461 0.295166L11.0527 5.92728L0.677019 11.5499H0.659363L0.668396 11.5544L0.659363 11.5594H0.677019L11.0527 17.182L21.4461 22.8141L31.8391 17.182L42.2148 11.5594H42.2325L42.2234 11.5544Z",
    fill: "#036185"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.677032 11.0968V33.6059L21.4461 22.3516L0.677032 11.0968Z",
    fill: "#64BCD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2147 11.0968V33.6059L21.446 22.3516L42.2147 11.0968Z",
    fill: "#64BCD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.5d77477892dde0c34479331a1bf2e025.svg";
export { ForwardRef as ReactComponent };